import { getLaunchDarklyClient } from '@Src/mfe.config';

/**
 * Resolves the device-auth gate from LaunchDarkly.
 *
 * @returns Promise<boolean> - true if device auth is enabled, false otherwise
 */
export async function resolveDeviceAuthEnabled(): Promise<boolean> {
    const ldClient = getLaunchDarklyClient();
    if (!ldClient) {
        return false;
    }

    try {
        return await ldClient.boolFlag('clienthub-v0-enable', false);
    } catch (err) {
        console.error('[Auth MFE] Failed to evaluate LaunchDarkly flag:', err);
        return false;
    }
}
